import { useSearchParams } from 'react-router-dom'

export function useQueryParams() {
  const [search, setSearch] = useSearchParams()
  const getParams = (paramName: string): string | undefined => search.get(paramName) || undefined

  const setParams = (paramName: string, paramValue: string) => {
    if (getParams(paramName)) {
      search.set(paramName, paramValue)
    } else {
      search.append(paramName, paramValue)
    }

    setSearch(search)
  }

  const removeParam = (paramName: string) => {
    if (getParams(paramName)) {
      search.delete(paramName)

      setSearch(search)
    }
  }

  const removeAllParams = () => setSearch({})

  return { getQuery: getParams, setQuery: setParams, removeQuery: removeParam, removeAll: removeAllParams }
}
